
const environment = {
	currentLanguage: 'it',
	facebook: {
		appId: '610048027052371',
		fields: 'id,name,first_name,last_name,email,gender,picture,cover,link',
		scope: 'public_profile, email', // publish_stream
		tokenClient: '951b013fe59b05cf471d869aae9ba6ba',
		version: 'v11.0',
	},
	google: {
		clientId: '760742757246-61qknlmthbmr54bh7ch19kjr0sftm4q3.apps.googleusercontent.com',
	},
	linkedIn: {
		clientId: '77cg5ls5lgu3k3',
		clientSecret: 'gfBIl365EdckxCgK',
		scope: 'r_emailaddress r_liteprofile',
	},
};

export class OnceService {
	static script$(url, callback) {
		// console.log('OnceScript.script$', url, callback);
		let item = this.paths.find(x => x.url === url);
		if (item != null) {
			return item.callback$;
		} else {
			item = { url, callbacks$: null };
			this.paths.push(item);
			let callbackName;
			if (callback === true) {
				callbackName = 'OnceCallback' + (++this.uid);
				url = url.split('{{callback}}').join(callbackName);
			} else {
				callbackName = callback;
			}
			let callback$;
			const script = document.createElement('script');
			script.type = 'text/javascript';
			if (callback) {
				callback$ = new Promise((resolve, reject) => {
					window[callbackName] = function(data) {
						// console.log('OnceScript', callbackName, data);
						resolve(data);
					};
				});
			} else {
				script.async = true;
				callback$ = new Promise((resolve, reject) => {
					script.onload = (event) => {
						resolve(event);
					};
				});
			}
			item.callback$ = callback$;
			const scripts = Array.prototype.slice.call(document.getElementsByTagName('script'));
			if (scripts.length) {
				script.src = url;
				const lastScript = scripts[scripts.length - 1];
				lastScript.parentNode.insertBefore(script, lastScript.nextSibling);
			}
			// console.log('OnceScript.script$', scripts.length, script.src, scripts.map(x => x.src).join(', '));
			return callback$;
		}
	}
}
OnceService.uid = 0;
OnceService.paths = [];

export class FacebookService {

	static facebook$() {
		return new Promise((resolve, reject) => {
			if (window.location.protocol.indexOf('https') !== -1) {
				if (this.facebook_) {
					resolve(this.facebook_);
				} else {
					OnceService.script$('//connect.facebook.net/' + environment.currentLanguage + '/sdk.js', 'fbAsyncInit').then(
						_ => {
							const facebook = window['FB'];
							facebook.init({
								appId: environment.facebook.appId,
								// status: true,
								cookie: true,
								xfbml: true,
								version: environment.facebook.version,
							});
							facebook.AppEvents.logPageView();
							this.facebook_ = facebook;
							resolve(facebook);
						},
						error => {
							reject(error);
						}
					);
				}
			} else {
				const message = 'FacebookService.facebook$.error https required';
				reject(message);
			}
		});
	}

	static status$() {
		return new Promise((resolve, reject) => {
			this.facebook$().then(
				facebook => {
					if (facebook !== null) {
						facebook.getLoginStatus((response) => {
							this.authResponse_ = null;
							if (response.status === 'connected') {
								this.authResponse_ = response.authResponse;
								resolve(response);
							} else if (response.status === 'not_authorized') {
								reject(response);
							} else {
								reject(null);
							}
						}, { scope: environment.facebook.scope });
					} else {
						reject(null);
					}
				},
				error => {
					reject(error);
				}
			);
		});
	}

	static login$() {
		return new Promise((resolve, reject) => {
			this.facebook$().then(
				facebook => {
					if (facebook !== null) {
						facebook.login((response) => {
							this.authResponse_ = null;
							if (response.status === 'connected') {
								this.authResponse_ = response.authResponse;
								resolve(response);
							} else if (response.status === 'not_authorized') {
								reject(response);
							} else {
								reject(response);
							}
						}, { scope: environment.facebook.scope });
					} else {
						reject(null);
					}
				},
				error => {
					console.log('FacebookService.login$.error', error);
					reject(error);
				}
			);
		});
	}

	static logout$() {
		return new Promise((resolve, reject) => {
			this.status$().then(
				facebook => {
					if (facebook !== null) {
						this.facebook_.logout(response => {
							resolve(response);
						});
					} else {
						reject(null);
					}
				},
				error => {
					reject(error);
				}
			);
		});
	}

	static me$(fields) {
		return new Promise((resolve, reject) => {
			this.status$().then(
				status => {
					if (status !== null) {
						fields = fields || environment.facebook.fields;
						this.facebook_.api('/me', {
							fields: fields,
							accessToken: environment.facebook.tokenClient,
						}, (response) => {
							if (!response || response.error) {
								const error = response ? response.error : 'error';
								console.log('FacebookService.getMe.error', error);
								reject(response.error);
							} else {
								const user = response;
								user.authResponse = this.authResponse_;
								user.facebookToken = this.authResponse_.accessToken;
								resolve(user);
							}
						});
					} else {
						this.login$().then(success => resolve(success), error => reject(error));
					}
				},
				error => {
					this.login$().then(success => resolve(success), error => reject(error));
				}
			);
		});
	}

}
FacebookService.facebook_ = null;
FacebookService.authResponse_ = null;


export class GoogleService {

	static google$() {
		return new Promise((resolve, reject) => {
			if (this.gapi) {
				resolve(this.gapi);
			} else {
				this.once$().then(success => resolve(success), error => reject(error));
			}
		});
	}

	static once$() {
		return new Promise((resolve, reject) => {
			return OnceService.script$('//apis.google.com/js/api:client.js?onload={{callback}}', true).then(
				_ => {
					this.gapi = window['gapi'];
					resolve(this.gapi);
				},
				error => reject(error),
			);
		});
	}

	static getAuth2$() {
		return new Promise((resolve, reject) => {
			const auth2Init = () => {
				this.gapi.auth2.init({
					client_id: environment.google.clientId,
					cookiepolicy: 'single_host_origin',
					scope: 'profile email',
					fetch_basic_profile: true,
					ux_mode: 'popup',
				}).then(() => {
					this.auth2 = this.gapi.auth2;
					// console.log('Auth2Init.success', this.auth2);
					resolve(this.auth2);
				}, reject);
			};
			if (this.auth2) {
				resolve(this.auth2);
			} else {
				this.google$().then(
					success => {
						if (this.gapi.auth2) {
							auth2Init();
						} else {
							this.gapi.load('auth2', () => {
								setTimeout(() => {
									auth2Init();
								}, 200);
							}, reject);
						}
					}, error => reject(error)
				);
			}
		});
	}

	static auth2Instance$() {
		return new Promise((resolve, reject) => {
			if (this.instance) {
				resolve(this.instance);
			} else {
				this.getAuth2$().then(success => {
					this.instance = this.auth2.getAuthInstance();
					resolve(this.instance);
				}, error => reject(error));
			}
		});
	}

	static login$() {
		return new Promise((resolve, reject) => {
			this.auth2Instance$().then(success => {
				this.signin$().then(success => resolve(success), error => reject(error));
			}, error => reject(error));
		});
	}

	static logout$() {
		return new Promise((resolve, reject) => {
			this.auth2Instance$().then(success => {
				if (this.instance.isSignedIn && this.instance.isSignedIn.get()) {
					this.instance.signOut().then((signed) => {
						resolve();
					}, reject);
				} else {
					resolve();
				}
			}, error => reject(error));
		});
	}

	static me$() {
		return new Promise((resolve, reject) => {
			this.login$().then(success => {
				const profile = this.instance.currentUser.get().getBasicProfile();
				const user = {
					id: profile.getId(),
					name: profile.getName(),
					firstName: profile.getGivenName(),
					lastName: profile.getFamilyName(),
					picture: profile.getImageUrl(),
					email: profile.getEmail(),
					authResponse: this.authResponse,
					googleToken: this.authResponse.access_token,
				};
				resolve(user);
			}, error => reject(error));
		});
	}

	static signin$() {
		return new Promise((resolve, reject) => {
			const readAccessToken = () => {
				// console.log('GoogleLogin.readAccessToken');
				try {
					const user = this.instance.currentUser.get().getAuthResponse(true);
					// console.log('GoogleLogin.readAccessToken.success', user);
					this.authResponse = user;
					resolve({
						code: user.access_token,
					});
				} catch (error) {
					console.log('GoogleLogin.readAccessToken.error', error);
					reject(error);
				}
			};
			if (this.instance.isSignedIn && this.instance.isSignedIn.get()) {
				readAccessToken();
			} else {
				this.instance.signIn({
					scope: 'profile email',
				}).then((signed) => {
					readAccessToken();
				}, (error) => {
					reject(error);
				});
			}
		});
	}

}

export class LinkedinService {

	static linkedin$() {
		return new Promise((resolve, reject) => {
			const key = 'linkedin';
			const state = `${key}-${new Date().getTime()}`;
			const onNext = (code) => {
				const data = {
					grant_type: 'authorization_code',
					code: code,
					client_id: environment.linkedIn.clientId,
					client_secret: environment.linkedIn.clientSecret,
					redirect_uri: `${window.location.origin}/IT/it/cassa`,
				};
				fetch('/api/user/linkedin', {
					method: 'POST', // *GET, POST, PUT, DELETE, etc.
					mode: 'cors', // no-cors, *cors, same-origin
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					credentials: 'same-origin', // include, *same-origin, omit
					headers: {
						'Content-Type': 'application/json'
						// 'Content-Type': 'application/x-www-form-urlencoded',
					},
					redirect: 'follow', // manual, *follow, error
					referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
					body: JSON.stringify(data) // body data type must match "Content-Type" header
				}).then(response => response.json()).then(user => {
					resolve(user);
				}, error => reject(error));
			};
			window.onSocialCallback = (social, params) => {
				if (social === 'linkedin' && params.state === state) {
					console.log('onSocialCallback', params.code);
					onNext(params.code);
				}
			};
			const width = 375 * 2;
			const height = 667;
			window.open(
				`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${environment.linkedIn.clientId}&redirect_uri=${window.location.origin}/giorgetti/cart.html&state=${state}&scope=${environment.linkedIn.scope}`,
				key,
				`top=${Math.floor((window.innerHeight - height) / 2)}, left=${Math.floor((window.innerWidth - width) / 2)}, width=${width}, height=${height}, status=no, menubar=no, toolbar=no scrollbars=no`,
			);
			// https://localhost:48481/giorgetti/cart.html?code=AQRqT4xWst4rcKM_sarxRTHP7PJ_eUbiQP30KZuyjGgSuoNQjZzJtSIu6laX6o-R-hy9obrIhzRKA3EshZfkIgo-ErIEahuyyAkY7Lg5PRFCEDdJxiy-cKyz8O9Vl6wVs2hoO_m7QvhLB22YfL_qqtToWqEUvWLwWqVTzRgEbu_U2AWDltOP_mSVNLge3Qc_uRV6VZDPeQqPcY2ICgo&state=foobar

		});
	}

}


export class SocialLoginService {

	static onFacebookLogin() {
		console.log('SocialLogin.onFacebookLogin');
		this.socialBusy = 'facebook';
		let socialMe;
		function mapMe(data) {
			// console.log(data);
			/*
			authResponse:
				accessToken: string
				data_access_expiration_time: 1633594543
				expiresIn: 5164299
				graphDomain: "facebook"
				signedRequest: string
				userID: string
			email: string
			facebookToken: string
			first_name: string
			id: string
			last_name: string
			name: string
			picture:
				data:
					height: 50
					is_silhouette: false
					url: string
					width: 50
			*/
			const me = {};
			if (data) {
				me.firstName = data.first_name;
				me.lastName = data.last_name;
				me.email = data.email;
				me.socialPicture = data.picture.data.url;
				me.socialType = 'facebook';
				me.socialId = data.id;
				me.socialToken = data.facebookToken;
				me.socialTokenExpiresAt = data.authResponse.data_access_expiration_time;
			}
			console.log('CartComponent.onFacebookLogin.mapMe', me);
			return me;
		}
		FacebookService.me$().then(
			me => {
				socialMe = me;
				// const user = UserService.tryFacebook$(me)
				const user = null;
				this.socialBusy = false;
				if (user) {
					this.onUser(user);
				} else {
					const me = mapMe(socialMe);
					this.onSignUp(me);
				}
			},
			error => {
				console.log('SocialLogin.onFacebookLogin.error', error);
				const me = mapMe(socialMe);
				this.onSignUp(me);
			});
	}

	static onGoogleLogin() {
		console.log('SocialLogin.onGoogleLogin');
		this.socialBusy = 'google';
		let socialMe;
		function mapMe(data) {
			// console.log(data);
			/*
			authResponse:
				access_token: string
				expires_at: 1625838392809
				expires_in: 3599
				first_issued_at: 1625834793809
				id_token: string
				idpId: "google"
				login_hint: string
				scope: "email profile openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
				session_state: {extraQueryParams: {…}}
				token_type: "Bearer"
			email: string
			firstName: string
			googleToken: string
			id: string
			lastName: string
			name: string
			picture: string
			*/
			const me = {};
			if (data) {
				me.firstName = data.firstName;
				me.lastName = data.lastName;
				me.email = data.email;
				me.socialPicture = data.picture;
				me.socialType = 'google';
				me.socialId = data.id;
				me.socialToken = data.googleToken;
				me.socialTokenExpiresAt = data.authResponse.expires_at;
			}
			console.log('CartComponent.onGoogleLogin.mapMe', me);
			return me;
		}
		GoogleService.me$().then(
			me => {
				socialMe = me;
				// const user = UserService.tryGoogle$(me)
				const user = null;
				this.socialBusy = false;
				if (user) {
					this.onUser(user);
				} else {
					const me = mapMe(socialMe);
					this.onSignUp(me);
				}
			},
			error => {
				console.log('SocialLogin.onGoogleLogin.error', error);
				const me = mapMe(socialMe);
				this.onSignUp(me);
			});
	}

	static onLinkedinLogin() {
		console.log('SocialLogin.onLinkedinLogin');
		this.socialBusy = 'linkedin';
		LinkedinService.linkedin$().then(
			me => {
				console.log('CartComponent.onLinkedinLogin', me);
				// const user = UserService.tryLinkedin$(me)
				const user = null;
				this.socialBusy = false;
				if (user) {
					this.onUser(user);
				} else {
					this.onSignUp(me);
				}
			}, error => {
				console.log('CartComponent.onLinkedinLogin.error', error);
				this.onSignUp(null);
			});
	}

	static onSignUp(me) {
		if (typeof (ga) !== "undefined")
			ga('send', 'event', 'Metodo acquisto', 'registrati');
		$(".noLogged").hide();
		$(".Logged").show();
		if (me) {
			console.log('SocialLogin.onSignUp', me);
			$("input#Nome").val(me.firstName);
			$("input#Cognome").val(me.lastName);
			$("input#Email").val(me.email);
		}
	}

	static onUser(user) {
	}

	static init() {
		const buttons = Array.prototype.slice.call(document.querySelectorAll('.nav--social button'));
		buttons.forEach(button => {
			button.addEventListener('click', (event) => {
				switch (button.getAttribute('data-social')) {
					case 'facebook':
						this.onFacebookLogin();
						break;
					case 'google':
						this.onGoogleLogin();
						break;
					case 'linkedin':
						this.onLinkedinLogin();
						break;
				}
			});
		});
	}

}

window.onload = () => {
	SocialLoginService.init();
};
